const xyoCurrentValue = 0.0055

export default xyoCurrentValue
